/** Matches MUI `Button` `size="small"` + Launch Readiness launcher styles in the header. */
export const HEADER_CONTROL_TYPOGRAPHY = {
  fontSize: '0.8125rem',
  fontWeight: 600,
  letterSpacing: 0,
} as const;
